import { getEnvironmentConfig, getEnvVariableDefault } from '../configHelper.js';
const snowplowDefinition = {
    base: {
        collectorEndpoint: 'https://staging.bf-tracking-production.aws.bfops.io/com.snowplowanalytics.snowplow/tp2',
        aidPrefix: 'ctf-headline-testing-',
        envLabel: 'dev',
    },
    production: {
        collectorEndpoint: 'https://sp.{brand}.de/com.snowplowanalytics.snowplow/tp2',
        envLabel: 'prod',
    },
};
const winnerApiDefinition = {
    base: {
        baseUrl: 'https://rt-api.bf-tracking-sandbox.aws.bfops.io',
        apiKey: getEnvVariableDefault('SNOWPLOW_REALTIME_API_KEY', ''),
    },
    local_e2e: {
        baseUrl: '',
        apiKey: '',
    },
    test: {
        baseUrl: 'https://winner-api.test',
        apiKey: 'test-snowplow-realtime-api-key',
    },
    production: {
        baseUrl: 'https://rt-api.bf-tracking-production.aws.bfops.io',
    },
};
export const abTestingSnowplowConfig = (brand) => {
    const config = getEnvironmentConfig(snowplowDefinition);
    return {
        ...config,
        collectorEndpoint: config.collectorEndpoint.replace('{brand}', brand),
    };
};
export const abTestingWinnerApiConfig = () => getEnvironmentConfig(winnerApiDefinition);
//# sourceMappingURL=ab-testing.config.js.map